import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import * as ROUTES from '../../constants/routes';

const Navigation = () => {
	return (
		<nav>
			<ul>
				<li>
					<NavLink to={ROUTES.EARLY} className="earlyChildhood">
						<div className="icon earlyChildhood" />	
						<span>Early Childhood</span>
					</NavLink>
				</li>
				<li>
					<NavLink to={ROUTES.ELEMENTARY} className="elementary">
						<div className="icon elementary" />	
						<span>Elementary</span>
					</NavLink>
				</li>
				<li>
					<NavLink to={ROUTES.PRETEEN} className="preteen">
						<div className="icon preteen" />	
						<span>Preteen</span>
					</NavLink>
				</li>
				<li>
					<NavLink to={ROUTES.HELP} className="help">
						<div className="icon help" />
						<span>Help</span>
					</NavLink>
				</li>
			</ul>
		</nav>
	);
};

export default withRouter(Navigation);